import React, { useState } from "react";

import { Preview } from "@creatomate/preview";

import { audios } from "app/utils/audios.json";
import AudioOption from "./AudioOption";

interface AudioOptionsProps {
  preview: Preview;
}

const AudioOptions: React.FC<AudioOptionsProps> = ({ preview }) => {
  const [playingIndex, setPlayingIndex] = useState<number | null>(null);

  const handlePlay = (index: number) => {
    setPlayingIndex(prev => (prev === index ? null : index));
  };

  return (
    <div className="Stories-Audios">
      {audios.map((audio, index) => (
        <AudioOption
          key={audio.name}
          isPlaying={playingIndex === index}
          audio={audio}
          onPlay={() => handlePlay(index)}
          preview={preview}
        />
      ))}
    </div>
  );
};

export default AudioOptions;
